var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{key:_vm.fieldKey,attrs:{"vid":_vm.field.hierarchy,"name":_vm.field.label,"rules":_vm.allRules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_vm._t("default",null,{"errors":errors})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }